import { Roarr } from 'roarr';

export const logger = Roarr.child({
  package: '@synapticon/motion-master-client',
});
